<div class="content text-center flex flex-column justify-content-center">
  <img src="/assets/img/vessel.svg" alt="Vessel">
  <p>{{ invalidVessel ? 'The url does not seem valid in this context. Please select a vessel.' : 'Page not found' }} </p>
</div>